export default "__VITE_ASSET__nlRUZfa2__"